//请自行添加语言资源
const order = {
  msg:{
  }
};
export default order



// WEBPACK FOOTER //
// ./src/page/report/distribute/lang/order.zh.js